/* eslint-disable camelcase */
import { updateDataLayerObjectFromCustomDimensions } from './utils/mapper';
import { ensureExperimentsInDataLayer } from './utils/ensureExperimentsInDataLayer';
import { getDataLayer } from './dataLayer';
import processForShortExperiments from './utils/processForShortExperiments';

/**
 * GA4 dual implementation HZ-4337
 * These event names are external requirements
 */
function sendGA4EventData(eventData: Record<string, unknown>) {
  const eventName = eventData?.eventAction || eventData?.event;

  if (!eventName || typeof eventName !== 'string') {
    return;
  }

  updateDataLayerObjectFromCustomDimensions(eventData);
  ensureExperimentsInDataLayer(); // UA approach
  const eventDataWithShortExperiments = processForShortExperiments(eventData);

  window?.dataLayer?.push({
    event_name: eventName,
    event_category: getDataLayer()?.pageType,
    ...eventDataWithShortExperiments,
    event: 'ga4Event',
  } as any);
}

export default sendGA4EventData;
